import Styles from './list-styles.scss';
import { SurveyItem, SurveyItemEmpty } from '@/presentation/pages/survey-list/components';
import React from 'react';
const List = ({ surveys }) => {
    return (React.createElement("ul", { className: Styles.listWrap, "data-testid": "survey-list" }, surveys.length ? (surveys.map((survey) => React.createElement(SurveyItem, { key: survey.id, survey: survey }))) : (React.createElement(SurveyItemEmpty, null))));
};
export default List;
